import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import type { ChainLpcLppSupplierRollup } from '~/types/services/priceParrot';

import { fmtAud, fmtInt } from '../PriceParrotChainParityDashboard/utils';

interface Props {
  rollup: ChainLpcLppSupplierRollup | undefined;
}

const TILE_SX = {
  flex: 1,
  minWidth: 160,
  p: 2,
  borderRadius: 2,
  bgcolor: 'grey.50',
  border: 1,
  borderColor: 'divider',
} as const;

export default function RollupSummaryTiles({ rollup }: Props) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
      <Box sx={TILE_SX}>
        <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>Bookings</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700 }}>{fmtInt(rollup?.bookings_count)}</Typography>
      </Box>
      <Box sx={TILE_SX}>
        <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>Margin AR</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700 }}>{fmtAud(rollup?.margin_ar_aud)}</Typography>
      </Box>
      <Box sx={TILE_SX}>
        <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>Avg margin / booking</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700 }}>{fmtAud(rollup?.avg_margin_per_booking_aud)}</Typography>
      </Box>
      <Box sx={TILE_SX}>
        <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>LPC / LPP views</Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 700 }}>
          {fmtInt(rollup?.lpc_views)} / {fmtInt(rollup?.lpp_views)}
        </Typography>
      </Box>
    </Stack>
  );
}
